// extracted by mini-css-extract-plugin
export default {"head-studio__container":"style_head-studio__container__nz39h","head-studio__title":"style_head-studio__title__6wKpP"};